var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.dataFrom ? _c("div", {
    staticClass: "node-item"
  }, [_c("div", {
    staticStyle: {
      width: "100%",
      position: "relative"
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 14
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("节点名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("节点名称"),
      disabled: !_vm.dataFrom.isEdit
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  }), _c("div", [_vm._v("*" + _vm._s(_vm.$t("所填节点名称为节点进度展示名称")))])], 1), _c("a-form-model-item", {
    attrs: {
      prop: "flowScheduleId",
      label: _vm.$t("归属流程")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("归属流程"),
      allowClear: "",
      disabled: !_vm.dataFrom.isEdit
    },
    model: {
      value: _vm.dataFrom.flowScheduleId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "flowScheduleId", $$v);
      },
      expression: "dataFrom.flowScheduleId"
    }
  }, _vm._l(_vm.process, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "reviewer",
      label: _vm.$t("审核人")
    }
  }, [!_vm.dataFrom.isSponsor && _vm.num !== 1 ? _c("a-button", {
    attrs: {
      type: "dashed",
      disabled: !_vm.dataFrom.isEdit
    },
    on: {
      click: function ($event) {
        return _vm.addpeopleFun(1, _vm.dataFrom.reviewer);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("添加审核人")))]) : _vm._e(), _c("a-checkbox", {
    staticClass: "marginL15",
    attrs: {
      disabled: !_vm.dataFrom.isEdit,
      checked: _vm.dataFrom.isSponsor
    },
    on: {
      change: _vm.launchChange
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("审核流发起人")) + " ")]), _c("div", _vm._l(_vm.dataFrom.reviewer, function (item) {
    return _c("a-tag", {
      key: item.userId,
      attrs: {
        color: "blue",
        closable: _vm.dataFrom.isEdit
      },
      on: {
        close: () => _vm.handleClose(item, 1)
      }
    }, [_vm._v(" " + _vm._s(item.customerName)), item.customerName ? _c("span", [_vm._v("/")]) : _vm._e(), _vm._v(_vm._s(item.nickName) + " ")]);
  }), 1)], 1), !_vm.dataFrom.isSponsor && _vm.num !== 1 ? _c("a-form-model-item", {
    attrs: {
      prop: "cc",
      label: _vm.$t("抄送人")
    }
  }, [_c("a-button", {
    attrs: {
      type: "dashed",
      disabled: !_vm.dataFrom.isEdit
    },
    on: {
      click: function ($event) {
        return _vm.addpeopleFun(2, _vm.dataFrom.cc);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("添加抄送人")))]), _c("div", _vm._l(_vm.dataFrom.cc, function (item) {
    return _c("a-tag", {
      key: item.userId,
      attrs: {
        color: "blue",
        closable: _vm.dataFrom.isEdit
      },
      on: {
        close: () => _vm.handleClose(item, 2)
      }
    }, [_vm._v(" " + _vm._s(item.customerName)), item.customerName ? _c("span", [_vm._v("/")]) : _vm._e(), _vm._v(_vm._s(item.nickName) + " ")]);
  }), 1), _c("div", {
    staticClass: "color"
  }, [_vm._v("*" + _vm._s(_vm.$t("抄送人无编辑权限仅支持查看")))])], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("多人审核时"),
      prop: "method"
    }
  }, [_c("a-radio-group", {
    attrs: {
      disabled: !_vm.dataFrom.isEdit
    },
    model: {
      value: _vm.dataFrom.method,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "method", $$v);
      },
      expression: "dataFrom.method"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "COUNTERSIGN"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("会签（需所有审核人同意后进入下一节点）")) + " ")]), _c("a-radio", {
    attrs: {
      value: "ORSIGN"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("或签 （其中一位审核人同意或拒绝即可进入下一节点）")) + " ")])], 1)], 1), _vm.num > 1 ? [_c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("文案页面")))])]), _c("a-form-model-item", {
    attrs: {
      prop: "copywriting",
      label: _vm.$t("文案内容")
    }
  }, [_c("a-textarea", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("文案内容"),
      disabled: !_vm.dataFrom.isEdit
    },
    model: {
      value: _vm.dataFrom.copywriting,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "copywriting", $$v);
      },
      expression: "dataFrom.copywriting"
    }
  })], 1), _c("a-form-model-item", {
    staticClass: "iconBox2",
    attrs: {
      prop: "copywritingIconName",
      label: _vm.$t("展示icon")
    }
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "dashed",
      disabled: !_vm.dataFrom.isEdit
    },
    on: {
      click: _vm.addiconFun
    }
  }, [_vm._v(_vm._s(_vm.$t("选择icon")))]), _vm.dataFrom.copywritingIconName ? _c("a-icon", {
    style: {
      fontSize: "30px",
      color: "#1890ff"
    },
    attrs: {
      type: _vm.dataFrom.copywritingIconName
    }
  }) : _vm._e(), _vm.dataFrom.copywritingIconName ? _c("a-button", {
    staticClass: "marginL15",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.deleteIcon
    }
  }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e()], 1), _c("a-form-model-item", {
    attrs: {
      required: _vm.dataFrom.copywriting.length || _vm.dataFrom.copywritingIconName.length,
      "validate-status": _vm.customerTagValidateObj.validateStatus,
      help: _vm.customerTagValidateObj.help,
      label: _vm.$t("可见客户类型")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("客户类型"),
      allowClear: "",
      mode: "multiple",
      disabled: _vm.disabledCustomTag
    },
    model: {
      value: _vm.dataFrom.customerTag,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "customerTag", $$v);
      },
      expression: "dataFrom.customerTag"
    }
  }, _vm._l(_vm.typeList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]);
  }), 1)], 1)] : _vm._e(), _c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("操作页面")))])]), _c("a-form-model-item", {
    attrs: {
      prop: "sharedPrevNode",
      label: _vm.$t("回显内容")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "580px"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("回显"),
      allowClear: "",
      mode: "multiple",
      disabled: !_vm.dataFrom.isEdit || _vm.num == 1
    },
    model: {
      value: _vm.dataFrom.sharedNode,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "sharedNode", $$v);
      },
      expression: "dataFrom.sharedNode"
    }
  }, _vm._l(_vm.echoList, function (item) {
    return _c("a-select-option", {
      key: item.step,
      attrs: {
        value: item.step
      }
    }, [_vm._v(" " + _vm._s(Number(item.step) === 0 ? _vm.$t("上一节点") : _vm.$t("第") + item.step + _vm.$t("节点")) + " ")]);
  }), 1), _vm.num != 1 ? _vm._l(_vm.selectEchoNodeList, function (item) {
    return _c("div", {
      key: item.step
    }, [_vm._v(" " + _vm._s(Number(item.step) === 0 ? _vm.$t("上一节点") : _vm.$t("第") + item.step + _vm.$t("节点")) + " " + _vm._s(_vm.showEditCheckBox ? ":" : "") + " "), _vm.showEditCheckBox ? _c("a-checkbox", {
      staticClass: "marginL15",
      attrs: {
        checked: item.isEdit,
        disabled: !_vm.dataFrom.isEdit
      },
      on: {
        change: e => _vm.echoNodeCheckChange(e, item)
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("可编辑")) + " ")]) : _vm._e()], 1);
  }) : _vm._e()], 2), _c("a-form-model-item", {
    attrs: {
      prop: "editableArea",
      label: _vm.$t("编辑表单区")
    }
  }, [_c("a-button", {
    attrs: {
      type: "dashed",
      disabled: !_vm.dataFrom.isEdit
    },
    on: {
      click: function ($event) {
        return _vm.editFun2([]);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("新增")))]), _vm._l(_vm.dataFrom.editableArea, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "form-preview"
    }, [_vm.dataFrom.isEdit ? _c("a-icon", {
      staticClass: "iconBox",
      attrs: {
        type: "edit"
      },
      on: {
        click: function ($event) {
          return _vm.editForm(item, index);
        }
      }
    }) : _vm._e(), _c("div", {
      staticStyle: {
        "margin-top": "20px"
      }
    }, [item.formName ? _c("top-title", {
      attrs: {
        background: true
      }
    }, [_c("span", {
      attrs: {
        slot: "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.formName) + " ")])]) : _vm._e(), _vm._l(item.form, function (item2, index2) {
      return _c("div", {
        key: index2,
        staticStyle: {
          width: "100%"
        }
      }, [item2.controlType === "controlGroup" ? [_c("div", {
        staticClass: "title_name"
      }, [_vm._v(_vm._s(_vm.$t(item2.controlName)))]), _vm._l(item2.control, function (item3, index3) {
        return _c("div", {
          key: index3,
          staticStyle: {
            width: "100%"
          }
        }, [_c("new-control-item", {
          attrs: {
            item2: item3,
            index: index3,
            isShow: true
          }
        })], 1);
      })] : _c("new-control-item", {
        attrs: {
          item2: item2.control,
          index: index2,
          isShow: true
        }
      })], 2);
    })], 2)], 1);
  })], 2), _c("a-form-model-item", {
    attrs: {
      prop: "actionButton",
      label: _vm.$t("操作按钮")
    }
  }, [_c("div", [_vm._l(_vm.dataFrom.actionButton, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "btnBox"
    }, [_c("div", [_c("a-input", {
      staticStyle: {
        "margin-right": "15px"
      },
      attrs: {
        placeholder: _vm.$t("请输入") + _vm.$t("按钮名字"),
        "max-length": 50,
        disabled: !_vm.dataFrom.isEdit
      },
      on: {
        change: _vm.clearTriggerButton
      },
      model: {
        value: item.name,
        callback: function ($$v) {
          _vm.$set(item, "name", $$v);
        },
        expression: "item.name"
      }
    }), _c("a-button", {
      attrs: {
        type: item.color
      }
    }, [_vm._v(_vm._s(item.name || _vm.$t("按钮名字")))]), _c("a-select", {
      staticClass: "marginL15",
      staticStyle: {
        width: "200px"
      },
      attrs: {
        placeholder: _vm.$t("请选择") + _vm.$t("颜色"),
        disabled: !_vm.dataFrom.isEdit
      },
      model: {
        value: item.color,
        callback: function ($$v) {
          _vm.$set(item, "color", $$v);
        },
        expression: "item.color"
      }
    }, _vm._l(_vm.colorList, function (item) {
      return _c("a-select-option", {
        key: item.id,
        attrs: {
          value: item.value
        }
      }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]);
    }), 1), index != 0 ? _c("a-button", {
      staticClass: "marginL15",
      attrs: {
        type: "danger",
        disabled: !_vm.dataFrom.isEdit
      },
      on: {
        click: function ($event) {
          return _vm.delBouttomFun(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e()], 1), _c("div", [_vm._v(" " + _vm._s(_vm.$t("事件：点击按钮跳转至")) + " "), _c("a-select", {
      staticClass: "marginL15",
      staticStyle: {
        width: "100%",
        flex: "1"
      },
      attrs: {
        disabled: !_vm.dataFrom.isEdit
      },
      on: {
        change: function ($event) {
          return _vm.gobackChange(item);
        }
      },
      model: {
        value: item.goBack,
        callback: function ($$v) {
          _vm.$set(item, "goBack", $$v);
        },
        expression: "item.goBack"
      }
    }, [_vm.num === 1 ? _vm._l(_vm.firstNodelist, function (item) {
      return _c("a-select-option", {
        key: item.id,
        attrs: {
          value: item.value
        }
      }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]);
    }) : _vm._l(_vm.nodeList, function (item) {
      return _c("a-select-option", {
        key: item.id,
        attrs: {
          value: item.value
        }
      }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]);
    })], 2), item.goBack == "DESIGNATE_NODE" ? _c("a-input-number", {
      staticClass: "marginL15",
      staticStyle: {
        width: "200px"
      },
      attrs: {
        placeholder: _vm.$t("请输入") + _vm.$t("节点"),
        precision: 0,
        parser: value => value.replace(/[^\d]/g, ""),
        disabled: !_vm.dataFrom.isEdit,
        min: 1
      },
      on: {
        change: _vm.clearTriggerButton
      },
      model: {
        value: item.node,
        callback: function ($$v) {
          _vm.$set(item, "node", $$v);
        },
        expression: "item.node"
      }
    }) : _vm._e()], 1), item.goBack === "PREVIEW_FILE" ? _c("div", {
      staticStyle: {
        width: "100%"
      }
    }, [_c("a-form-model-item", {
      staticStyle: {
        width: "100%",
        flex: "1"
      },
      attrs: {
        label: _vm.$t("关联文件模板"),
        "label-col": {
          span: 4
        },
        "wrapper-col": {
          span: 16
        },
        required: "",
        "validate-status": "error",
        help: _vm.$t(item.fileEmptyTipMessage)
      }
    }, [_c("a-upload", {
      staticClass: "upload-list-inline",
      attrs: {
        action: _vm.action,
        multiple: true,
        "file-list": item.fileList,
        accept: ".doc,.docx",
        disabled: !_vm.dataFrom.isEdit,
        data: {
          module: "fileTemplate"
        },
        headers: {
          "X-Dispatch": "Upload",
          "X-Version": "upload"
        }
      },
      on: {
        change: e => _vm.handleChange(e, item),
        preview: _vm.previewFile
      }
    }, [_c("div", [_c("a-button", {
      attrs: {
        type: "link",
        block: "",
        disabled: !_vm.dataFrom.isEdit
      }
    }, [_c("a-icon", {
      attrs: {
        type: "plus"
      }
    }), _vm._v(_vm._s(_vm.$t("上传文件模板")))], 1)], 1)])], 1)], 1) : _vm._e()]);
  }), _vm.dataFrom.actionButton.length < 5 ? _c("a-button", {
    attrs: {
      type: "dashed",
      disabled: !_vm.dataFrom.isEdit
    },
    on: {
      click: _vm.addButton
    }
  }, [_vm._v(_vm._s(_vm.$t("新增操作按钮")))]) : _vm._e()], 2)]), _c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("消息通知")))])]), _c("a-form-model-item", {
    attrs: {
      prop: "type",
      label: _vm.$t("发送方式")
    }
  }, [_c("a-radio-group", {
    attrs: {
      disabled: !_vm.dataFrom.isEdit,
      "button-style": "solid"
    },
    model: {
      value: _vm.notifyObj.type,
      callback: function ($$v) {
        _vm.$set(_vm.notifyObj, "type", $$v);
      },
      expression: "notifyObj.type"
    }
  }, [_c("a-radio-button", {
    class: _vm.notifyObj.type === "EMAIL" ? "" : "btn-bg",
    attrs: {
      value: "EMAIL"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("邮件发送")) + " ")])], 1)], 1), _vm.notifyObj.type === "EMAIL" ? _c("div", [_c("a-form-model-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      prop: "type",
      label: _vm.$t("收件人邮箱")
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      size: "small",
      disabled: !_vm.dataFrom.isEdit
    },
    on: {
      click: function ($event) {
        return _vm.addEmail("recipient");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("添加")) + " ")])], 1), _c("div", {
    staticClass: "emails-container"
  }, _vm._l(_vm.notifyObj.recipient, function (item, index) {
    return _c("a-tag", {
      key: item + index,
      attrs: {
        closable: _vm.dataFrom.isEdit,
        color: "#108ee9"
      },
      on: {
        close: function ($event) {
          return _vm.deleteEmail("recipient", index);
        }
      }
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 1), _c("a-row", {
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "10px",
      "margin-left": "8.3%"
    }
  }, [_c("a-col", {
    attrs: {
      span: 3
    }
  }, [_c("a-checkbox", {
    attrs: {
      checked: _vm.notifyObj.is_cc,
      disabled: !_vm.dataFrom.isEdit
    },
    on: {
      change: e => _vm.onCheckChange(e, "is_cc")
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("添加抄送人")) + " ")])], 1), _c("a-col", {
    attrs: {
      span: 3
    }
  }, [_c("a-checkbox", {
    attrs: {
      checked: _vm.notifyObj.is_bcc,
      disabled: !_vm.dataFrom.isEdit
    },
    on: {
      change: e => _vm.onCheckChange(e, "is_bcc")
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("添加密送人")) + " ")])], 1)], 1), _vm.notifyObj.is_cc ? _c("a-form-model-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      prop: "type",
      label: _vm.$t("抄送人邮箱")
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      size: "small",
      disabled: !_vm.dataFrom.isEdit
    },
    on: {
      click: function ($event) {
        return _vm.addEmail("cc");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("添加")) + " ")])], 1) : _vm._e(), _vm.notifyObj.is_cc ? _c("div", {
    staticClass: "emails-container"
  }, _vm._l(_vm.notifyObj.cc, function (item, index) {
    return _c("a-tag", {
      key: item + index,
      attrs: {
        closable: _vm.dataFrom.isEdit,
        color: "#108ee9"
      },
      on: {
        close: function ($event) {
          return _vm.deleteEmail("cc", index);
        }
      }
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 1) : _vm._e(), _vm.notifyObj.is_bcc ? _c("a-form-model-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      prop: "type",
      label: _vm.$t("密送人邮箱")
    }
  }, [_vm.notifyObj.is_bcc ? _c("a-button", {
    attrs: {
      type: "primary",
      size: "small",
      disabled: !_vm.dataFrom.isEdit
    },
    on: {
      click: function ($event) {
        return _vm.addEmail("bcc");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("添加")) + " ")]) : _vm._e()], 1) : _vm._e(), _vm.notifyObj.is_bcc ? _c("div", {
    staticClass: "emails-container"
  }, _vm._l(_vm.notifyObj.bcc, function (item, index) {
    return _c("a-tag", {
      key: item + index,
      attrs: {
        closable: _vm.dataFrom.isEdit,
        color: "#108ee9"
      },
      on: {
        close: function ($event) {
          return _vm.deleteEmail("bcc", index);
        }
      }
    }, [_vm._v(" " + _vm._s(item) + " ")]);
  }), 1) : _vm._e(), _c("h3", {
    staticClass: "email-title"
  }, [_vm._v(_vm._s(_vm.$t("邮件内容")))]), _c("a-form-model-item", {
    attrs: {
      prop: "title",
      label: _vm.$t("邮件主题")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: !_vm.dataFrom.isEdit,
      "max-length": 100,
      placeholder: _vm.$t("请输入") + _vm.$t("邮件主题")
    },
    model: {
      value: _vm.notifyObj.title,
      callback: function ($$v) {
        _vm.$set(_vm.notifyObj, "title", $$v);
      },
      expression: "notifyObj.title"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("邮件正文")
    }
  }, [_c("quill-editor", {
    ref: "myTextEditor",
    staticStyle: {
      height: "540px"
    },
    attrs: {
      options: _vm.quillOption,
      disabled: !_vm.dataFrom.isEdit
    },
    model: {
      value: _vm.notifyObj.content,
      callback: function ($$v) {
        _vm.$set(_vm.notifyObj, "content", $$v);
      },
      expression: "notifyObj.content"
    }
  })], 1), _vm.allFileTemplate.length > 0 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("关联模板")
    }
  }, [_c("a-select", {
    attrs: {
      disabled: !_vm.dataFrom.isEdit,
      mode: "multiple",
      placeholder: _vm.$t("请选择")
    },
    model: {
      value: _vm.notifyObj.fileTemplate,
      callback: function ($$v) {
        _vm.$set(_vm.notifyObj, "fileTemplate", $$v);
      },
      expression: "notifyObj.fileTemplate"
    }
  }, _vm._l(_vm.allFileTemplate, function (item) {
    return _c("a-select-option", {
      key: item.url,
      attrs: {
        value: item.url
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1) : _vm._e(), _c("a-row", {
    attrs: {
      gutter: 24
    }
  }, [_c("a-col", {
    attrs: {
      span: 6
    }
  }, [_c("a-form-model-item", {
    attrs: {
      labelCol: {
        span: 8
      },
      label: _vm.$t("用户确认")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择"),
      disabled: !_vm.dataFrom.isEdit,
      allowClear: ""
    },
    model: {
      value: _vm.notifyObj.operate.userConfirm,
      callback: function ($$v) {
        _vm.$set(_vm.notifyObj.operate, "userConfirm", $$v);
      },
      expression: "notifyObj.operate.userConfirm"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "need"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("需要")) + " ")])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("触发条件"),
      labelCol: {
        span: 6
      }
    }
  }, [_c("div", {
    staticClass: "trigger-class"
  }, [_c("a-select", {
    attrs: {
      disabled: !_vm.dataFrom.isEdit,
      placeholder: _vm.$t("请选择"),
      allowClear: "",
      getPopupContainer: triggerNode => triggerNode.parentNode
    },
    on: {
      change: _vm.triggerWhereChange
    },
    model: {
      value: _vm.notifyObj.operate.triggerWhere,
      callback: function ($$v) {
        _vm.$set(_vm.notifyObj.operate, "triggerWhere", $$v);
      },
      expression: "notifyObj.operate.triggerWhere"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "button"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("操作按钮")) + " ")])], 1), _c("a-select", {
    attrs: {
      mode: "multiple",
      disabled: !_vm.dataFrom.isEdit || !_vm.notifyObj.operate.triggerWhere,
      placeholder: _vm.$t("请选择")
    },
    model: {
      value: _vm.notifyObj.operate.value,
      callback: function ($$v) {
        _vm.$set(_vm.notifyObj.operate, "value", $$v);
      },
      expression: "notifyObj.operate.value"
    }
  }, _vm._l(_vm.allActionButton, function (item) {
    return _c("a-select-option", {
      key: item.name + item.index,
      attrs: {
        value: String(item.index)
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1)])], 1)], 1)], 1) : _vm._e()], 2), _c("div", {
    staticStyle: {
      position: "absolute",
      right: "20px",
      top: "20px"
    }
  }, [_vm.dataFrom.isEdit ? _c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存")) + " ")]) : _vm._e(), !_vm.dataFrom.isEdit ? _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onEdit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("编辑")) + " ")]) : _vm._e(), _vm.dataFrom.isEdit && _vm.num != 1 || _vm.dataFrom.isEdit && _vm.dataFrom.id ? _c("a-button", {
    staticClass: "marginL15",
    on: {
      click: function ($event) {
        _vm.infoFun(), _vm.$emit("cancel", _vm.num - 1);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("取消")) + " ")]) : _vm._e()], 1)], 1), _vm.peopleShow ? _c("people-model", {
    ref: "peopleFrom",
    on: {
      cancel: function ($event) {
        _vm.peopleShow = false;
      },
      peopleOk: _vm.peopleOk
    }
  }) : _vm._e(), _vm.iconShow ? _c("icon-model", {
    ref: "iconFrom",
    on: {
      cancel: function ($event) {
        _vm.iconShow = false;
      },
      iconOk: _vm.iconOk
    }
  }) : _vm._e(), _vm.addEmailVisible ? _c("emailModel", {
    attrs: {
      addEmailTitle: _vm.addEmailTitle,
      addEmailVisible: _vm.addEmailVisible
    },
    on: {
      getEmails: _vm.settingEmail,
      cancelAddEmail: _vm.cancelAddEmail
    }
  }) : _vm._e(), _vm.editShow2 ? _c("newedit-model", {
    ref: "editFrom",
    attrs: {
      itemid: _vm.itemid,
      editIndex: _vm.editIndex,
      allForm: _vm.dataFrom.editableArea
    },
    on: {
      "tabulate-Data": _vm.tabulateData,
      cancel: _vm.cancelOk,
      controlOk: _vm.controlOk
    }
  }) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };